import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CommonfileService } from '../../sag/commonfile.share.service';

//declare function alerts(m): any;
@Injectable()
export class CustomHttpInterceptorService implements HttpInterceptor {
    constructor(
        private _router : Router,
        private activeRoute : ActivatedRoute,
        public _shareService: CommonfileService) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      if (typeof localStorage !== "undefined") {
        const accessToken = localStorage.getItem('accessToken');

        if (accessToken) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${accessToken}`
            }
          });
        }
      }
      
      this._shareService.loading++;
        return next.handle(request).pipe(
          map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              if(event.body && event.body.status == 401){
                //  this._router.navigate(["/login"], { relativeTo: this.activeRoute });
                //alerts("session Expired. Please Login Again..! ");
               
              }
              this._shareService.loading--;
            }
           
            return event;
          }),
       );
      }


}